import { reactive } from 'vue';
import { use18n } from 'src/utils/v2_helper/common';

const useAboutPayTip = () => {
  const { $t } = use18n();
  const stepList = [
    {
      id: 1,
      title: $t('waiting.howPayQrisStep1'),
      img: 'https://static.bakmigm.co.id/menu/payType/step1.png',
    },
    {
      id: 2,
      title: $t('waiting.howPayQrisStep2'),
      img: 'https://static.bakmigm.co.id/menu/payType/step2.png',
    },
    {
      id: 3,
      title: $t('waiting.howPayQrisStep3'),
      img: 'https://static.bakmigm.co.id/menu/payType/step3.png',
    },
  ];
  const platformList = [
    {
      id: 'M-BCA',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisMBCA.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/BCA1.png', text: $t('waiting.qrisMBCAStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/BCA2.png', text: $t('waiting.qrisMBCAStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/BCA3.png', text: $t('waiting.qrisMBCAStep3') }
      ],
    },
    {
      id: "Livin' by Mandiri",
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisLivinby Mandiri.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/LivinbyMandiri1.png', text: $t('waiting.qrisLivenByMandiriStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/LivinbyMandiri2.png', text: $t('waiting.qrisLivenByMandiriStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/LivinbyMandiri3.png', text: $t('waiting.qrisLivenByMandiriStep3') },
      ],
    },
    {
      id: 'BRImo',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisBRImo.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/BRI1.png', text: $t('waiting.qrisBRIMOStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/BRI2.png', text: $t('waiting.qrisBRIMOStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/BRI3.png', text: $t('waiting.qrisBRIMOStep3') },
      ],
    },
    {
      id: 'Permata Mobile',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisPermata.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/PermataMobile1.png', text: $t('waiting.qrisPermataMobileStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/PermataMobile2.png', text: $t('waiting.qrisPermataMobileStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/PermataMobile3.png', text: $t('waiting.qrisPermataMobileStep3') },
      ],
    },
    {
      id: 'Gopay',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisGopay.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/Gopay1.png', text: $t('waiting.qrisGoPayStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/Gopay2.png', text: $t('waiting.qrisGoPayStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/Gopay3.png', text: $t('waiting.qrisGoPayStep3') },
      ],
    },
    {
      id: 'Shopeepay',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisShopepay.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/ShopeePay1.png', text: $t('waiting.qrisShopeePayStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/ShopeePay2.png', text: $t('waiting.qrisShopeePayStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/ShopeePay3.png', text: $t('waiting.qrisShopeePayStep3') },
      ],
    },
    {
      id: 'OVO',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisOVO.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/OVO1.png', text: $t('waiting.qrisOVOStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/OVO2.png', text: $t('waiting.qrisOVOStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/OVO3.png', text: $t('waiting.qrisOVOStep3') },
      ],
    },
    {
      id: 'DANA',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisDana.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/Dana1.png', text: $t('waiting.qrisDANAStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/Dana2.png', text: $t('waiting.qrisDANAStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/Dana3.png', text: $t('waiting.qrisDANAStep3') },
      ],
    },
    {
      id: 'LinkAja',
      icon: 'https://static.bakmigm.co.id/menu/payType/qrisLinkAja.png',
      steps: [
        { img: 'https://static.bakmigm.co.id/menu/payType/LinkAja1.png', text: $t('waiting.qrisLinkAjaStep1') },
        { img: 'https://static.bakmigm.co.id/menu/payType/LinkAja2.png', text: $t('waiting.qrisLinkAjaStep2') },
        { img: 'https://static.bakmigm.co.id/menu/payType/LinkAja3.png', text: $t('waiting.qrisLinkAjaStep3') },
      ],
    },
  ];
  const payTipDialog = reactive({
    show: false,
    currentItem: platformList[0],
  });
  const openDialogByType = (item) => {
    payTipDialog.currentItem = item;
    payTipDialog.show = true;
  };
  return {
    stepList, platformList, openDialogByType, payTipDialog
  }
}

export { useAboutPayTip }
